module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/mplan1-e88c386dc9b119b7911434aaea0f438b.jpg";